import AddIcon from '@mui/icons-material/Add';
import { Box, Dialog, DialogContent, Divider, Typography } from '@mui/material';
import BusinessSearcherAutocomplete from 'lib/common/BusinessSearcherAutocomplete';
import CreateContact from 'lib/common/Forms/Contacts/Create';
import DialogTitle from 'lib/designSystem/Title/DialogTitle';
import { Business } from 'lib/types/models';
import React, { useState } from 'react';

type Props = {
  setOpen: (open: boolean) => void;
  open: boolean;
};

const NewContact: React.FC<Props> = (props: Props) => {
  const { setOpen, open } = props;
  const [business, setBusiness] = useState<Business | null>(null);
  const [searched, setSearched] = useState(false);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle
        title="Nuevo contacto"
        icon={<AddIcon color="primary" />}
        onClose={() => setOpen(false)}
        color="primary"
      />
      <DialogContent>
        <BusinessSearcherAutocomplete
          setBusiness={setBusiness}
          setSearched={setSearched}
        />
        {searched && <Divider sx={{ my: 1 }} />}

        {business && (
          <Box mt={1}>
            <CreateContact
              businessIdentifier={business.identifier}
              onCreated={() => setOpen(false)}
            />
          </Box>
        )}
        {!business && searched && (
          <Box mt={1}>
            <Typography>
              No encontramos una empresa con ese rut en tu red. Por favor
              verifica el rut o crea la empresa antes de agregar un contacto.
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default NewContact;
